import createStyled from './createStyled';
const styled = createStyled();
export default styled;


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/styled.js
// module id = 255
// module chunks = 22